import AlgoliaService from './AlgoliaService';
import { CookieName } from '../common/Constants';
import fetchHelper from '../common/fetchHelper';
import { isNewAlgoliaIndexEnabled } from '../common/eventEditions';

const renewAlgoliaToken = async (baseApiUrl, eventEditionId, interfaceLocale) => {
  if (fetchHelper.getCookie(CookieName.ALGOLIA_TOKEN)) {
    fetchHelper.deleteCookie(CookieName.ALGOLIA_TOKEN);
  }
  const isNewIndex = isNewAlgoliaIndexEnabled(eventEditionId);
  const response = await AlgoliaService.getApiKey(baseApiUrl, eventEditionId, interfaceLocale, isNewIndex);
  const { token, expiryEpochTime } = response.result;
  const expiryUTCString = new Date(expiryEpochTime * 1000).toUTCString();
  fetchHelper.setCookie(CookieName.ALGOLIA_TOKEN, token, expiryUTCString);
  return { result: token };
};

const getAlgoliaToken = async (baseApiUrl, eventEditionId, interfaceLocale) => {
  let algoliaCookie = fetchHelper.getCookie(CookieName.ALGOLIA_TOKEN);

  if (typeof algoliaCookie === 'undefined') {
    const response = await renewAlgoliaToken(baseApiUrl, eventEditionId, interfaceLocale);
    algoliaCookie = response.result;
  }

  return { result: algoliaCookie };
};
export default { getAlgoliaToken, renewAlgoliaToken };
